import { createSlice } from "@reduxjs/toolkit";

export interface NotificationsPageInterface {
    currentPage: number;
    itemsPerPage: number;
    itemsPerPageSelect: { value: number; activeValue: boolean }[];
}

const initialState: NotificationsPageInterface = {
    currentPage: 1,
    itemsPerPage: 12,
    itemsPerPageSelect: [
        { value: 12, activeValue: true },
        { value: 25, activeValue: false },
        { value: 50, activeValue: false },
    ],
};

const NotificationsSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setItemsPerPage: (state, action) => {
            state.itemsPerPage = action.payload;

            state.itemsPerPageSelect = state.itemsPerPageSelect.map((item) => {
                return {
                    ...item,
                    activeValue: item.value === action.payload,
                };
            });
        },
    },
});

export const notificationsReducer = NotificationsSlice.reducer;
export const { setCurrentPage, setItemsPerPage } = NotificationsSlice.actions;
